// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-media {
  position: relative;
  width: 270px;
  height: 150px;
  object-fit: cover;
  border-radius: 15px;
  display: block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.project-media-wrapper {
  position: relative;
  display: inline-block;
}

.project-media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20%;
  background-color: rgba(0, 0, 0, 0.437);
  display: flex;
  align-items: center;
  padding: 0px 10px 10px 10px;
  gap: 10px;
  border-radius: 15px 15px 0px 0px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  z-index: 2;
}

.project-media-wrapper:hover .project-media-overlay {
  opacity: 1;
  pointer-events: auto;
}

.project-icon-mdi {
  font-size: 1rem;
  font-weight: 100;
  color: #fff;
  cursor: pointer;
  pointer-events: auto;
}

.project-media-empty {
  border: 1px dotted gray;
  border-radius: 15px;
  width: 270px;
  height: 150px;
}

.transition-container {
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.transition-container.collapsed {
  max-height: 0;
  opacity: 0;
}

.transition-container.expanded {
  max-height: 1000px;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/components/CandidateProjectDetailsSection/CandidateProjectDetailsSection.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,wEAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,oCAAA;EACA,oBAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,iEAAA;AACF;;AAEA;EACE,aAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF","sourcesContent":[".project-media {\n  position: relative;\n  width: 270px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 15px;\n  display: block;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n.project-media-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.project-media-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 20%;\n  background-color: rgba(0, 0, 0, 0.437);\n  display: flex;\n  align-items: center;\n  padding: 0px 10px 10px 10px;\n  gap: 10px;\n  border-radius: 15px 15px 0px 0px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.project-media-wrapper:hover .project-media-overlay {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.project-icon-mdi {\n  font-size: 1rem;\n  font-weight: 100;\n  color: #fff;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.project-media-empty {\n  border: 1px dotted gray;\n  border-radius: 15px;\n  width: 270px;\n  height: 150px;\n}\n\n.transition-container {\n  overflow: hidden;\n  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;\n}\n\n.transition-container.collapsed {\n  max-height: 0;\n  opacity: 0;\n}\n\n.transition-container.expanded {\n  max-height: 1000px;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
